<template>
  <div class="custom-control custom-checkbox">
    <input
        :id="id"
        v-model="value"
        :name="name"
        class="custom-control-input"
        type="checkbox"
    />
    <label :for="id" class="custom-control-label">
      <slot/>
      <span class="error-message">{{ error }}</span>
    </label>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  modelValue?: string | boolean
  id: string
  name: string
  errors?: string[]
  initialValue?: boolean
}

const props = withDefaults(
    defineProps<Props>(),
    { initialValue: false}
)
const {id, initialValue, name} = props
const emit = defineEmits(['update:modelValue', 'blur', 'focus'])

const {value} = useField(() => name, undefined, {initialValue})
const error = computed(() => {
  return props.errors?.join(', ')
})
</script>
